<template>
  <div class="container">
    <table cellspacing="20">
      <tr>
        <td style="width: 170px;">CODIGO DE COMPROBANTE</td>
        <td style="font-weight: bold;"># {{ value.CodigoComprobante }}</td>
      </tr>
      <tr>
        <td>TIPO</td>
        <td>{{ tipo(value.Tipo) }}</td>
      </tr>
      <tr>
        <td>FECHA</td>
        <td>{{ value.Fecha }}</td>
      </tr>
      <tr>
        <td>VENCIMIENTO</td>
        <td>{{ value.FechaVencimiento }}</td>
      </tr>
      <tr>
        <td>IMPORTE</td>
        <td>$ {{ value.Importe | formatMoney }}</td>
      </tr>
      <tr>
        <td>SALDO</td>
        <td>$ {{ value.Saldo | formatMoney }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import HeaderSales from "@components/views/header.vue";
export default {
  components: { "header-sales": HeaderSales, },
  computed: {
    value () {
      return this.$store.state.modal.value
    }
  },
  methods: {
    tipo (key) {
      switch (key) {
        case 1:
          return 'FACTURA'
          break;
        case 2:
          return 'NOTA DE CREDITO'
          break;
        case 3:
          return 'NOTA DE DEBITO'
          break;
        case 4:
          return 'RECIBO'
          break;
      }
    },
  }
}
</script>

<style scoped>
  #subheader {
    width: 100%;
    height: 35vh;
    background: linear-gradient(#005A9F , #1899D6);
    }


   #main-container{
    position: absolute;
    top: 55vh;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 700px;
    height: 85vh;
    }


   #label-container{
     width: 700px;
     height: 10vh;
    }

   #label{
     color:#ffffff;
     font-size: 27px;
    }


   #container{
     width: 700px;
     height: 65vh;
     border-width: 1px;
     border: 1px solid #dddddd;
     box-sizing: border-box;
     background-color: #ffffff;
    }

.container {
  color: #656e76;
  font-size: 10px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ctacte/comprobante.vue